// extracted by mini-css-extract-plugin
export var container = "styles-module--container--z2EoE";
export var desktop = "1340px";
export var dockedBottom = "styles-module--dockedBottom--N9b8o";
export var dockedTop = "styles-module--dockedTop--GiM7q";
export var figure = "styles-module--figure--aIdW2";
export var giant = "2200px";
export var grid = "styles-module--grid--eNPNa";
export var image = "styles-module--image--iA5Qj";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var padded = "styles-module--padded--QNOcm";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";